import { AppActionTypes, SetSelectedProducerPayload } from 'store/app/actions/types'

export const SET_SELECTED_PRODUCER = 'APP/SET_SELECTED_PRODUCER'

export const setSelectedProducer = ({ producer }: SetSelectedProducerPayload): AppActionTypes => {
  return { type: SET_SELECTED_PRODUCER, producer }
}
